import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=1e5872df&"
import script from "./RetrievePassword.vue?vue&type=script&lang=js&"
export * from "./RetrievePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports